(() => {
  const rawBrandNames = (typeof window !== 'undefined' && /** @type {any} */ (window)['GY_BRAND_NAMES']) || '';
  if (!rawBrandNames || typeof rawBrandNames !== 'string') return;

  const TITLE_SELECTORS = ['.product-card__title-link', '.resource-list__item .product-card .product-title'];

  /**
   * @param {string} input
   * @returns {string}
   */
  const escapeRegExp = (input) => input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const brandList = rawBrandNames
    .split(',')
    .map((name) => name.trim())
    .filter((name) => name.length > 0);

  if (brandList.length === 0) return;

  const SEPARATOR_PATTERN = '[\\s\\-\u2013\u2014\u2212]+';
  const brandPatterns = brandList
    .slice()
    .sort((a, b) => b.length - a.length)
    .map((brand) => {
      const tokens = brand
        .split(/[\s\-]+/)
        .filter(Boolean)
        .map(escapeRegExp);
      const patternStr = tokens.join(SEPARATOR_PATTERN);
      return new RegExp(patternStr, 'gi');
    });

  /**
   * @param {Document|Element} root
   */
  function applyBrandBold(root = document) {
    /** @type {Element[]} */
    const elements = [];
    const scope = root instanceof Element ? root : document;
    for (const selector of TITLE_SELECTORS) {
      if (root instanceof Element && root.matches(selector)) elements.push(root);
      elements.push(...scope.querySelectorAll(selector));
    }
    if (elements.length === 0) return;

    const processed = new Set();

    elements.forEach((el) => {
      const target = el.matches('a') ? el : el.querySelector('a') || el;
      if (!(target instanceof Element)) return;
      if (processed.has(target)) return;
      processed.add(target);

      const originalText = target.textContent || '';
      if (!originalText) return;

      let updated = originalText;
      for (const pattern of brandPatterns) {
        updated = updated.replace(pattern, (match) => `<strong>${match}</strong>`);
      }

      if (updated !== originalText) {
        target.innerHTML = updated;
      }
    });
  }

  applyBrandBold(document);

  let rafId = 0;
  const schedule = () => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      applyBrandBold(document);
    });
  };

  document.addEventListener('filter:update', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
  document.addEventListener('shopify:section:select', schedule);
  document.addEventListener('shopify:section:deselect', schedule);
  window.addEventListener('popstate', schedule);

  /**
   * @param {Element} el
   * @returns {boolean}
   */
  const isRelevantElement = (el) => TITLE_SELECTORS.some((sel) => el.matches(sel) || el.closest(sel));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      // React when relevant elements are added
      if (mutation.type === 'childList') {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          const isRelevant = isRelevantElement(node) || TITLE_SELECTORS.some((sel) => node.querySelector(sel));
          if (isRelevant) {
            schedule();
            return;
          }
        }

        // Also react when the target itself is a relevant element whose children changed
        if (mutation.target instanceof Element) {
          const isTargetRelevant = isRelevantElement(mutation.target);
          if (isTargetRelevant) {
            schedule();
            return;
          }
        }
      }

      // React when text content changes inside a relevant title element
      if (mutation.type === 'characterData') {
        /** @type {Element | null} */
        const parent =
          mutation.target instanceof Element
            ? mutation.target
            : /** @type {any} */ (mutation.target).parentElement || null;
        if (parent && parent instanceof Element) {
          const isRelevant = isRelevantElement(parent);
          if (isRelevant) {
            schedule();
            return;
          }
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, characterData: true, subtree: true });
})();
